export default __webpack_public_path__ + "static/media/Shravanabelagol.151ec54d.jpg";